import { genericActions } from "../../Everou/_actions/generic.actions";
import { PMSLocationsMapper } from "../_mappers/PMSLocationsMapper";
import { PMSLocationsService } from "../_services/PMSLocationsService";
import { PMS_LOCATIONS_ACTION_TYPES } from "../_actionTypes/PMS_LOCATIONS_ACTION_TYPES";
import { PMSLocationsPaginationQueryParams, PMSLocationsPaginatedItems } from "../_models/Pagination";
import { PMS_LOCATIONS_SECONDARY_VIEWS } from "../_constants/pmslocations.constants";
import { PMSLocationsSecondaryViewStore } from "../_stores/PMSLocationsSecondaryViewStore";
import { DEVICE_TYPES, GLOBAL_POPUPS, INVITATION_PERIODS, INVITATION_TYPES, NO_NEXT_PAGE } from "../../Everou/_constants";
import { Selectors } from "../../Everou/_reducers/app.reducer";
import { PMSLocationLogsDateFilter } from "../_stores/PMSLocationLogsDateFilter";
import { PMSLocationLogsCollection } from "../_stores/PMSLocationLogsCollection";
import { PMSLocationProtectLogsDateFilter } from "../_stores/PMSLocationProtectLogsDateFilter";
import { PMSLocationProtectLogsCollection } from "../_stores/PMSLocationProtectLogsCollection";
import { deviceService } from "../../Everou/_services";
import { InvitationsMapper, LogsMapper } from "../../Everou/_mappers";
import {
    PMSLocationInfoMapper,
    PMS_LOCATION_SETTING_FIELDS,
} from "../_mappers/PMSLocationInfoMapper";
import { PMSLocationReservationsCollection } from "../_stores/PMSLocationReservationsCollection";
import { IntegrationMapper } from "../../Everou/_mappersTS/IntegrationMapper";
import { customizationService } from "../../Everou/_services/customization.service";
import { LocationCustomizationMapper } from "../../Everou/_mappers/LocationCustomizationMapper";
import { locationService } from "../../Everou/_services";
import { PMSLocationIntegrationsCollection } from "../_stores/PMSLocationIntegrationsCollection";
import { InvitationGroupMapper } from "../../Everou/_mappers/InvitationGroupMapper";
import { PMSLocationGroupsCollection } from "../_stores/PMSLocationGroupsCollection";
import { PMSIntegrationCreateServer, PMSIntegrationUpdateServer } from "../_models/PMSIntegration";
import { PMSReservationMapper } from "../_mappers/PMSReservationMapper";
import { Invitation } from "../../Everou/_models/Invitation";
import { globalActions } from "../../Everou/_actions";
import { PMSUserActions } from "./PMSUserActions";

export const PMSLocationsActions = {
    getPMSLocations,
    changeFilter,
    changeOffset,

    changeSecondaryView: PMSLocationsSecondaryViewStore.actionSet,
    selectPMSLocation,

    getLocationLogsFirstPage,
    getLocationLogsNextPage,
    getLocationLogsPage,
    setDateFilter: PMSLocationLogsDateFilter.actionSetBeginEnd,
    listLogsRequest: PMSLocationLogsCollection.actionListItemsRequest,
    listLogsSuccess: PMSLocationLogsCollection.actionListItemsSuccess,

    getProtectLogsFirstPage,
    getProtectLogsNextPage,
    getProtectLogsPage,
    getTriggeredProtectLogs,
    setProtectLogsDateFilter: PMSLocationProtectLogsDateFilter.actionSetBeginEnd,
    listProtectLogsRequest: PMSLocationProtectLogsCollection.actionListItemsRequest,
    listProtectLogsSuccess: PMSLocationProtectLogsCollection.actionListItemsSuccess,

    toggleProtectDevice,

    getLocationInfo,

    getReservations,
    reservationsRequest: PMSLocationReservationsCollection.actionListItemsRequest,
    reservationsSuccess: PMSLocationReservationsCollection.actionListItemsSuccess,

    getCustomization,
    updateCustomization,
    uploadLogo,
    deleteLogo,
    uploadBackground,

    updateLocationName,

    createNewLocationTag,
    deleteLocationTag,

    getIntegrations,
    integrationsRequest: PMSLocationIntegrationsCollection.actionListItemsRequest,
    integrationsSuccess: PMSLocationIntegrationsCollection.actionListItemsSuccess,

    getGroupsForLocation,
    groupsRequest: PMSLocationGroupsCollection.actionListItemsRequest,
    groupsSuccess: PMSLocationGroupsCollection.actionListItemsSuccess,

    addLocationIntegration,
    updateLocationIntegration,
    moveLocationIntegrationTemplate,
    moveLocationIntegrationTemplateUi,
    deleteLocationIntegration,
    deleteLocationIntegrationUi,

    updateURLRecommendations,
    updateTravelerDiscount,
    updateTimezone,
    updateCoordinates,
    updateInvitationLinkAddToHome,
    updateInvitationLinkAppName,
    updateInvitationLinkHideHeader,
    updateInvitationLinkHideFooter,
    updateEarlyCheckinEnabled,
    updateEarlyCheckoutEnabled,
    updateInvitationLinkLocationCheckMode,
    updateInvitationLinkLocationRadius,
    updateEnableProtectGuest,
    updateSecurityAlertTime,
    clearOrganizationSettingOverride,

    uploadVideo,
    deleteVideo,

    changeProtectStatus,
    changeAutoProtectSetting,

    updateURLVideo,

    createLocalReservation,
    deleteReservationDraft,
    changeReservationBeginTime,
    changeReservationEndTime,
    updateSelectedReservationLocally, // Generic selected invitation modifier
    updateNewReservationLocally,
    setReservationGuestName,
    setReservationGuestEmail,
    setReservationSendEmail,
    changeReservationGroup,

    createReservation,

    deleteReservationUi,
    deleteReservation,

    updateReservation,

    updatePublicDeviceOverrides,
};

function changeFilter(filter) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_CHANGE_FILTER,
        filter
    };
}

function getPMSLocations(query: PMSLocationsPaginationQueryParams = { offset: 0}) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(
            getLocations,
            () => { dispatch(_listPMSLocationsFailure()); dispatch(setIsRequesting(false));},
        ));

        async function getLocations() {
            dispatch(setIsRequesting(true));
            let res = await PMSLocationsService.list({ ...query });
            res.locations = PMSLocationsMapper.mapAllServerToLocal(res.locations);
            res.locations = [
                ...new Map(
                    (res.locations ?? []).map((location: any) => [location.uid, location]),
                ).values(),
            ];
            dispatch(_listPMSLocationsSuccess({
                items: res.locations ?? [], 
                offset: query.offset,
                page_size: query.page_size,
                total_count: res.total_count ?? 0
            }));
            dispatch(setIsRequesting(false));
        }
    }
}

function setIsRequesting(status: boolean = true) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_SET_REQUESTING_STATUS,
        status
    }
}

function _listPMSLocationsSuccess(locations: Partial<PMSLocationsPaginatedItems>) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_LIST_SUCCESS,
        locations
    };
}

function _listPMSLocationsFailure() {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_LIST_FAILURE,
    }
}

function changeOffset(offset) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_CHANGE_OFFSET,
        offset
    };
}

function selectPMSLocation(locationUid) {
    return dispatch => {
        const selectedView = locationUid
            ? PMS_LOCATIONS_SECONDARY_VIEWS.LOCATION_INFO
            : null
        ;

        dispatch(PMSLocationsActions.changeSecondaryView(selectedView));
        dispatch(selectLocation(locationUid));
    }

    function selectLocation(locationUid) {
        return {
            type: PMS_LOCATIONS_ACTION_TYPES.LOCATIONS_SELECT,
            locationUid
        };
    }
}

function getLocationLogsFirstPage() {
    return async dispatch => {
        await dispatch(getLogsPage(0));
    };
}

function getLogsPage(page = 0) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (Selectors.getPMSLocationSelectedUid(getState()) === null)
                return;
            
            await dispatch(PMSLocationsActions.getLocationLogsPage(page));
            return;
        }
    }
}

function getLocationLogsNextPage(nextPage = NO_NEXT_PAGE, isRequesting = false) {
    return async dispatch => {
        if (isRequesting || nextPage === NO_NEXT_PAGE)
            return;

        await dispatch(getLogsPage(nextPage));
    };
}

function getLocationLogsPage(page = 0) {
    return async (dispatch, getState) => {
        dispatch(PMSLocationsActions.listLogsRequest(page));
        const { begin, end } = Selectors.getPMSLocationLogsDateFilter(getState());
        const { logs, next } = await PMSLocationsService.getLogs(
            Selectors.getPMSLocationSelectedUid(getState()),
            begin,
            end,
            25,
            page,
        );

        const localLogs = LogsMapper.mapAllServerToLocal(logs);
        dispatch(PMSLocationsActions.listLogsSuccess(localLogs, next));

        return {
            localLogs,
            next
        };
    }
}

// PROTECT ACTIVITY LOGS — same flow as the location logs above but against the
// protect log endpoint and its own (parallel) store, so the Alarm tab's
// activity doesn't clash with the Activity tab's logs.
function getProtectLogsFirstPage() {
    return async dispatch => {
        await dispatch(getProtectLogsPageInternal(0));
    };
}

function getProtectLogsNextPage(nextPage = NO_NEXT_PAGE, isRequesting = false) {
    return async dispatch => {
        if (isRequesting || nextPage === NO_NEXT_PAGE)
            return;

        await dispatch(getProtectLogsPageInternal(nextPage));
    };
}

function getProtectLogsPageInternal(page = 0) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (Selectors.getPMSLocationSelectedUid(getState()) === null)
                return;

            await dispatch(PMSLocationsActions.getProtectLogsPage(page));
        }
    }
}

function getProtectLogsPage(page = 0) {
    return async (dispatch, getState) => {
        dispatch(PMSLocationsActions.listProtectLogsRequest(page));
        const { begin, end } = Selectors.getPMSLocationProtectLogsDateFilter(getState());
        const { logs, next } = await PMSLocationsService.getProtectLogs(
            Selectors.getPMSLocationSelectedUid(getState()),
            begin,
            end,
            25,
            page,
        );

        const localLogs = LogsMapper.mapAllServerToLocal(logs);
        dispatch(PMSLocationsActions.listProtectLogsSuccess(localLogs, next));

        return {
            localLogs,
            next
        };
    }
}

// Currently-triggered protect events. Resolves to the mapped logs so the caller
// can tell whether the alarm has gone off (non-empty).
function getTriggeredProtectLogs() {
    return async (dispatch, getState) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const uid = Selectors.getPMSLocationSelectedUid(getState());
            if (!uid)
                return [];

            const logs = await PMSLocationsService.getTriggeredProtectLogs(uid);
            return LogsMapper.mapAllServerToLocal(logs);
        }
    }
}

// Toggle whether a device belongs to Protect (the alarm). Mirrors the Everou
// Protect behaviour: the membership is the device's `notification` flag. Re-fetch
// the location so the device list reflects the new state.
function toggleProtectDevice(device) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const updateDeviceServiceFn =
                device.type === DEVICE_TYPES.Brain
                    ? deviceService.updateBrain
                    : deviceService.updateDevice;

            await updateDeviceServiceFn({
                uid: device.uid,
                notification: !device.notification,
            });

            await dispatch(getLocationInfo());
        }
    }
}

function getLocationInfo() {
    return async (dispatch, getState) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const serverLocationInfo = await PMSLocationsService.locationInfo(
                Selectors.getPMSLocationSelectedUid(getState())
            );

            const localLocationInfo = PMSLocationInfoMapper.mapServerToLocal(serverLocationInfo);
            localLocationInfo.devices = PMSLocationInfoMapper.serverLocationInfoToLocalDevices(serverLocationInfo);
            dispatch(success(localLocationInfo));
            return localLocationInfo;
        }
    };

    function success(locationInfo) {
        return {
            type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_INFO_GET_SUCCESS,
            locationInfo,
        };
    }
}

// Filters last used to list the selected location's reservations. The
// automatic refetches after create/update/delete don't know what the
// reservations view is filtering by; defaulting to the last-used filters
// keeps the reloaded list consistent with the filter bar instead of
// silently reloading unfiltered.
let lastReservationsFilters = {};

function getReservations(filters = lastReservationsFilters) {
    lastReservationsFilters = filters;
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (Selectors.getPMSLocationSelectedUid(getState()) === null)
                return;

            await dispatch(loadReservations(filters));
            return;
        }

    }
}

function loadReservations(filters = {}) {
    return async (dispatch, getState) => {
        dispatch(PMSLocationsActions.reservationsRequest());

        const serverReservations = await PMSLocationsService.reservations(
            Selectors.getPMSLocationSelectedUid(getState()),
            filters,
        );
        const localReservations = PMSReservationMapper.allServerToLocal(serverReservations);
        dispatch(PMSLocationsActions.reservationsSuccess(localReservations));

        return localReservations;
    }
}

function getCustomization() {
    return async (dispatch, getState) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getPMSLocationSelectedUid(getState());
            const response = await customizationService.getLocationInfo(locationUid);

            const localCustomization = LocationCustomizationMapper.serverToLocal(response);
            dispatch(success(localCustomization, locationUid));
            return localCustomization;
        };

        // The uid travels with the result: the header paints the location's
        // colours, and without knowing which location they belong to it would
        // keep showing the previous one's while the new fetch is in flight.
        function success(locationCustomization, locationUid) {
            return {
                type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_CUSTOMIZATION_GET_SUCCESS,
                locationCustomization,
                locationUid,
            }
        };
    }
}

function updateCustomization(accentColor, headerColor) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getPMSLocationSelectedUid(getState());
            const response = await customizationService.update(
                locationUid,
                accentColor,
                headerColor,
            );

            const localCustomization = LocationCustomizationMapper.serverToLocal(response);
            // Same uid the get flow stores: without it the stored
            // customization would look like nobody's and the header would
            // drop this location's colours right after editing one.
            dispatch(success(localCustomization, locationUid));
            return localCustomization;
        }

        function success(locationCustomization, locationUid) {
            return {
                type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_CUSTOMIZATION_GET_SUCCESS,
                locationCustomization,
                locationUid,
            }
        };
    };
}

function uploadLogo(image) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getPMSLocationSelectedUid(getState());
            dispatch(setIsUploadingImage(true));
            try {
                await customizationService.uploadLogo(locationUid, image);
                // The upload responds with no body, so re-read the
                // customization: otherwise the screen keeps showing the
                // previous (or inherited) logo until the location is reopened.
                // Inside the flag, so the control never reports "uploaded"
                // while it is still painting the old image.
                await dispatch(getCustomization());
            } finally {
                dispatch(setIsUploadingImage(false));
            }

            return true;
        }

        function setIsUploadingImage(isUploadingImage) {
            return {
                type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_CUSTOMIZATION_IS_UPLOADING_SET,
                isUploadingImage
            }
        }
    };
}

function deleteLogo() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getPMSLocationSelectedUid(getState());
            // Same flag the uploads raise: removing one is just as slow, and
            // without it the control shows no progress at all.
            dispatch(setIsUploadingImage(true));
            try {
                await customizationService.deleteLogo(locationUid);
                // Dropping the location's own logo brings the template's back,
                // so the merged value has to be re-read.
                await dispatch(getCustomization());
            } finally {
                dispatch(setIsUploadingImage(false));
            }

            return true;
        }

        function setIsUploadingImage(isUploadingImage) {
            return {
                type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_CUSTOMIZATION_IS_UPLOADING_SET,
                isUploadingImage
            }
        }
    };
}

function uploadBackground(image) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const locationUid = Selectors.getPMSLocationSelectedUid(getState());
            dispatch(setIsUploadingImage(true));
            try {
                await customizationService.uploadBackground(locationUid, image);
                await dispatch(getCustomization());
            } finally {
                dispatch(setIsUploadingImage(false));
            }

            return true;
        }

        function setIsUploadingImage(isUploadingImage) {
            return {
                type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_CUSTOMIZATION_IS_UPLOADING_SET,
                isUploadingImage
            }
        }
    };
}

function updateLocationName(name, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await locationService.updateLocationName({
                uid: locationUid,
                name,
            });
            await dispatch(getPMSLocations());
            await dispatch(getLocationInfo());
        }
    }
}

function createNewLocationTag(tag, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.createNewLocationTag({
                tag,
                locationUid
            });
            await dispatch(getPMSLocations());
            await dispatch(PMSUserActions.getTags());
        }
    }
}

function deleteLocationTag(tag, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.deleteLocationTag({
                tag,
                locationUid
            });
            await dispatch(getPMSLocations());
            await dispatch(PMSUserActions.getTags());
        }
    }
}

function getIntegrations() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (Selectors.getPMSLocationSelectedUid(getState()) === null)
                return;
            
            await dispatch(loadIntegrations());
            return;
        }
        
    }
}

function loadIntegrations() {
    return async (dispatch, getState) => {
        dispatch(PMSLocationsActions.integrationsRequest());

        const serverIntegrations = await PMSLocationsService.integrations(
            Selectors.getPMSLocationSelectedUid(getState())
        );
        const localIntegrations = IntegrationMapper.allServerToLocal(serverIntegrations);
        dispatch(PMSLocationsActions.integrationsSuccess(localIntegrations));

        return localIntegrations;
    }
}

function getGroupsForLocation() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (Selectors.getPMSLocationSelectedUid(getState()) === null)
                return;
            
            await dispatch(loadGroups());
            return;
        }
        
    }
}

function loadGroups() {
    return async (dispatch, getState) => {
        dispatch(PMSLocationsActions.groupsRequest());

        const serverGroups = await PMSLocationsService.groups(
            Selectors.getPMSLocationSelectedUid(getState())
        );
        const localGroups = InvitationGroupMapper.allServerToLocal(serverGroups);
        dispatch(PMSLocationsActions.groupsSuccess(localGroups));

        return localGroups;
    }
}

function addLocationIntegration(serverIntegration: PMSIntegrationCreateServer) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const integration = await PMSLocationsService.createLocationIntegration(serverIntegration);

            // Refresh the location groups too: saving an integration creates/updates
            // its invitation group, and the rooms selector restores its selection
            // from that group. Without this, the in-memory groups stay stale and the
            // just-saved rooms disappear until a full reload.
            dispatch(getGroupsForLocation());
            dispatch(getIntegrations());

            // Refresh the locations list so its "no PMS" badge reflects the
            // change (the list's has_integration field is otherwise stale).
            dispatch(getPMSLocations());

            return integration;
        }
    }
}

function updateLocationIntegration(update: PMSIntegrationUpdateServer) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const integration = await PMSLocationsService.updateLocationIntegration(update);

            // Same refresh as a create: the invitation group is re-scoped to the
            // new rooms, so pull groups + integrations back in to keep the rooms
            // selector and summary in sync without a full reload.
            dispatch(getGroupsForLocation());
            dispatch(getIntegrations());

            // Keep the locations list "has PMS" badge accurate.
            dispatch(getPMSLocations());

            return integration;
        }
    }
}

// Move an integration to another template (BAC-520). The credentials and
// settings are re-copied server-side from the new template, so the whole
// integration list is pulled back in rather than patched locally.
function moveLocationIntegrationTemplate(integrationUid: string, templateUid: string, rooms: string[]) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const integration = await PMSLocationsService.moveLocationIntegrationTemplate({
                integration_uid: integrationUid,
                template_uid: templateUid,
                // The backend takes `rooms` as the full assignment on every
                // update, so the current ones travel along untouched.
                rooms,
            });

            dispatch(getGroupsForLocation());
            dispatch(getIntegrations());

            return integration;
        }
    }
}

function deleteLocationIntegration(integrationUid: string, deleteInvitations: boolean = true) {
    return async (dispatch) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            await PMSLocationsService.deleteLocationIntegration(integrationUid, deleteInvitations);
            dispatch(PMSLocationIntegrationsCollection.actionDeleteItem(integrationUid));

            // Refresh the locations list so its "no PMS" badge reflects the
            // change (the list's has_integration field is otherwise stale).
            dispatch(getPMSLocations());
        }
    }
}

function updateURLRecommendations(url, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateLocationURLRecommendations({
                uid: locationUid,
                url_recommendations: url,
            });
            await dispatch(getLocationInfo());
        }
    }
}

function updateTimezone(timezone, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateTimezone({
                uid: locationUid,
                timezone,
            });
            await dispatch(getPMSLocations());
            await dispatch(getLocationInfo());
        }
    }
}

// The coordinates gate the "required" option of the public-link location check,
// so re-fetch the location info: that dropdown only offers it once they exist.
function updateCoordinates(latitude, longitude, address, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateCoordinates({
                uid: locationUid,
                latitude,
                longitude,
                address,
            });
            await dispatch(getLocationInfo());
        }
    }
}

function updateInvitationLinkAddToHome(enabled, locationUid) {
    return async dispatch => {
        // The toggle reflects the change optimistically; on success we avoid
        // re-fetching so the CSS transition isn't interrupted by a re-render.
        // On failure we re-sync the UI with the server state.
        dispatch(setLocationSettingLocally(
            { invitation_link_add_to_home: enabled },
            locationUid,
        ));
        dispatch(genericActions.genericAsyncAction(asyncAction, onError));

        async function asyncAction() {
            await PMSLocationsService.updateInvitationLinkAddToHome({
                uid: locationUid,
                invitation_link_add_to_home: enabled,
            });
        }

        function onError() {
            dispatch(getLocationInfo());
        }
    }
}

function updateInvitationLinkAppName(name, locationUid) {
    return async dispatch => {
        // The input reflects the value optimistically; on success we avoid
        // re-fetching so the UI updates instantly. On failure we re-sync with
        // the server state.
        dispatch(setLocationSettingLocally(
            { invitation_link_app_name: name },
            locationUid,
        ));
        dispatch(genericActions.genericAsyncAction(asyncAction, onError));

        async function asyncAction() {
            await PMSLocationsService.updateInvitationLinkAppName({
                uid: locationUid,
                invitation_link_app_name: name,
            });
        }

        function onError() {
            dispatch(getLocationInfo());
        }
    }
}

// The screens keep the value they just wrote in local state, but that state is
// born from the store: leaving the tab and coming back rebuilt it from the
// value the location was fetched with, so the change seemed to be lost until a
// reload. Write it to the store too — and mark the setting as the location's
// own, or its caption keeps claiming the value is inherited.
function setLocationSettingLocally(serverFields, locationUid) {
    return (dispatch, getState) => {
        // A debounced write can be flushed after the user opened another
        // location: it still posts to the location it was made in, but the
        // store now holds a different one and must not be stamped with it.
        const locationInfo = Selectors.getPMSLocationInfo(getState());
        if (locationUid && locationInfo?.uid && locationInfo.uid !== locationUid)
            return;

        const localFields = Object.entries(PMS_LOCATION_SETTING_FIELDS).reduce(
            (result, [localField, serverField]) => {
                if (Object.prototype.hasOwnProperty.call(
                    serverFields,
                    serverField,
                ))
                    result[localField] = serverFields[serverField];

                return result;
            },
            {},
        );

        dispatch({
            type: PMS_LOCATIONS_ACTION_TYPES.LOCATION_INFO_UPDATE_LOCALLY,
            fields: localFields,
        });
    };
}

// Shared optimistic update for a single location field. The UI already
// reflects the value, so on success we skip the re-fetch (keeps CSS
// transitions smooth) and only re-sync with the server on error.
function updateLocationField(fields, locationUid) {
    return async dispatch => {
        dispatch(setLocationSettingLocally(fields, locationUid));
        return dispatch(genericActions.genericAsyncAction(asyncAction, onError));

        async function asyncAction() {
            await PMSLocationsService.updateLocationField({
                uid: locationUid,
                ...fields,
            });
        }

        function onError() {
            dispatch(getLocationInfo());
        }
    }
}

function updateEarlyCheckinEnabled(enabled, locationUid) {
    return updateLocationField({ early_checkin_enabled: enabled }, locationUid);
}

function updateInvitationLinkLocationCheckMode(mode, locationUid) {
    return updateLocationField(
        { invitation_link_location_check_mode: mode },
        locationUid,
    );
}

function updateInvitationLinkLocationRadius(radius, locationUid) {
    return updateLocationField(
        { invitation_link_location_radius: radius },
        locationUid,
    );
}

function updateInvitationLinkHideHeader(hidden, locationUid) {
    return updateLocationField(
        { invitation_link_hide_header: hidden },
        locationUid,
    );
}

function updateInvitationLinkHideFooter(hidden, locationUid) {
    return updateLocationField(
        { invitation_link_hide_footer: hidden },
        locationUid,
    );
}

function updateEarlyCheckoutEnabled(enabled, locationUid) {
    return updateLocationField({ early_checkout_enabled: enabled }, locationUid);
}

function updateEnableProtectGuest(enabled, locationUid) {
    return updateLocationField({ enable_protect_guest: enabled }, locationUid);
}

function updateSecurityAlertTime(seconds, locationUid) {
    return updateLocationField({ security_alert_time: seconds }, locationUid);
}

function clearOrganizationSettingOverride(field, locationUid) {
    return async dispatch => {
        await dispatch(updateLocationField({ [field]: null }, locationUid));
        // Unlike optimistic edits, clearing an override changes the value to
        // whatever is currently inherited, which the client cannot know.
        await dispatch(getLocationInfo());
    };
}

function updateTravelerDiscount(travelerDiscount, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateLocationTravelerDiscount({
                uid: locationUid,
                traveler_discount: travelerDiscount,
            });
            await dispatch(getPMSLocations());
            await dispatch(getLocationInfo());
        }
    }
}

function uploadVideo(video, locationUid) {
    return async dispatch => {
        return dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await locationService.uploadVideo({
                locationUid,
                video
            });
            await dispatch(getLocationInfo());
        }
    }
}

function deleteVideo(locationUid) {
    return async dispatch => {
        return dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await locationService.deleteVideo({ locationUid });
            await dispatch(getLocationInfo());
        }
    }
}

function changeProtectStatus(enabled, locationUid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const isProtectOn = !Selectors.getLocationInfo(getState()).isProtectOn;
            await PMSLocationsService.changeProtectStatus(
                enabled,
                locationUid
            );

            dispatch(getPMSLocations());
            dispatch(getLocationInfo());
        }
    }
}

function changeAutoProtectSetting(enabled, locationUid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction, onError));

        ////
        async function asyncAction() {
            await PMSLocationsService.changeAutoProtectSetting(
                enabled,
                locationUid
            );

            // Re-fetch because enabling this also flips `protect` and
            // `protect_schedule_enabled` on the backend (mutually exclusive
            // modes), so the optimistic local value isn't the whole story.
            dispatch(getPMSLocations());
            dispatch(getLocationInfo());
        }

        // On failure (e.g. error_code 741 when the plan isn't Premium) re-sync
        // from the server so the optimistic toggle reverts. Returns nothing so
        // the mapped error message still surfaces to the user.
        function onError() {
            dispatch(getLocationInfo());
        }
    }
}

function updateURLVideo(url, locationUid) {
    return async dispatch => {
        dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateURLVideo({
                uid: locationUid,
                external_video_url: url,
            });
            await dispatch(getLocationInfo());
        }
    }
}

function createLocalReservation(locationUid) {
    return (dispatch, getState) => {
        const invitation = Invitation({
            newInvitation: true,
            type: INVITATION_TYPES.LOCATION,
            objectUid: locationUid,
            createPublicUrl: true
        });
        dispatch(createDraftReservation(invitation));
    };
}

function createDraftReservation(invitation) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.CREATE_LOCAL_RESERVATION,
        invitation,
    };
}

function deleteReservationDraft() {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.DELETE_LOCAL_RESERVATION
    }
}

function updateNewReservationLocally(selectedModified) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.RESERVATION_UPDATE_NEW_DRAFT_LOCALLY,
        selectedModified,
    };
}

function updateSelectedReservationLocally(selectedModified) {
    return {
        type: PMS_LOCATIONS_ACTION_TYPES.RESERVATION_UPDATE_SELECTED_LOCALLY,
        selectedModified,
    };
}

function changeReservationBeginTime(startMoment, isNew = false) {

    const dispatcher = isNew ? updateNewReservationLocally : updateSelectedReservationLocally;

    return dispatch => {
        dispatch(dispatcher({ begin: startMoment }));
    };
}

function changeReservationEndTime(end, isNew = false) {

    const dispatcher = isNew ? updateNewReservationLocally : updateSelectedReservationLocally;

    return dispatch => {
        dispatch(dispatcher({ end, periodType: !!end ? INVITATION_PERIODS.TEMPORARY : INVITATION_PERIODS.ALWAYS }));
    };
}

function setReservationGuestName(name: string = "") {
    return updateNewReservationLocally({ name });
}

function setReservationGuestEmail(email: string = "") {
    return updateNewReservationLocally({ email });
}

function setReservationSendEmail(sendEmail: boolean = false) {
    return updateNewReservationLocally({ sendEmail });
}

function changeReservationGroup(integration_uid: string, groups: any[] = []) {
    return updateNewReservationLocally({ integration_uid, groups });
}

function createReservation() {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {

            const localReservation = Selectors.getPMSReservationNewDraft(getState());
            const integration_uid = localReservation.integration_uid;
            const group_id = localReservation.groups[0].id;
            const serverInvitation = InvitationsMapper.mapNewLocalToServer(localReservation);

            const email = localReservation.email ?? "";

            await PMSLocationsService.createReservation(
                integration_uid,
                group_id,
                serverInvitation.begin,
                serverInvitation.end,
                email,
                localReservation.name ?? "",
                // Only send the email when a guest email was actually provided.
                !!email && !!localReservation.sendEmail
            );
            await dispatch(getReservations());
        }
    };
}

function deleteReservationUi(reservation: any) {
    return dispatch => {
        dispatch(globalActions.showPopUp(
            GLOBAL_POPUPS.DELETE_RESERVATION,
            { reservation }
        ));
    }
}

function moveLocationIntegrationTemplateUi(
    integrationUid: string,
    templates: any[],
    currentTemplateUid: string | null | undefined,
    currentTemplateName: string | null | undefined,
    rooms: string[],
) {
    return dispatch => {
        dispatch(globalActions.showPopUp(
            GLOBAL_POPUPS.MOVE_INTEGRATION_TEMPLATE,
            { integrationUid, templates, currentTemplateUid, currentTemplateName, rooms }
        ));
    }
}

function deleteLocationIntegrationUi(integrationUid: string) {
    return dispatch => {
        dispatch(globalActions.showPopUp(
            GLOBAL_POPUPS.DELETE_INTEGRATION,
            { integrationUid }
        ));
    }
}

function deleteReservation(reservation_uid) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {

            await PMSLocationsService.deleteReservation(
                reservation_uid
            );
            await dispatch(getReservations());
        }
    };
}

function updateReservation(reservation_uid, begin, end) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updateReservation(
                reservation_uid,
                begin,
                end
            );
            await dispatch(getReservations());
        }
    };
}

type PublicDeviceOverride = {
    deviceUid: string;
    mode: "hidden" | "code_only";
};

function updatePublicDeviceOverrides(
    overrides: PublicDeviceOverride[],
    locationUid: string,
) {
    return async dispatch => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await PMSLocationsService.updatePublicDeviceOverrides({
                uid: locationUid,
                overrides,
            });
            await dispatch(getLocationInfo());
        }
    };
}
